import { render, staticRenderFns } from "./release_page.vue?vue&type=template&id=4055d0fd&scoped=true"
import script from "./release_page.vue?vue&type=script&lang=js"
export * from "./release_page.vue?vue&type=script&lang=js"
import style0 from "./release_page.vue?vue&type=style&index=0&id=4055d0fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055d0fd",
  null
  
)

export default component.exports